import { ClientStatusWrapper } from './styles'
import { useTranslation } from 'react-i18next'

interface IProps {
  status: 'activated' | 'pending_partner_check' | 'canceled'
}

const ClientStatus = (props: IProps) => {
  const { t } = useTranslation()

  return (
    <ClientStatusWrapper status={props.status} >
      {t(`clients.status.${props.status}`)}
      <span/>
    </ClientStatusWrapper>
  )
}

export default ClientStatus
